import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/en';
export const locale = {
  lang: 'en',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
        'PRODUCTOS': catalogos.productos,
      },
      'TITULO': 'Survey calendar',
      'SUBTITULO': 'Consult the information of the surveys generated in the platform in a specific range.',
      'TXT_RANG_DAT':'Enter a date range',
      'BTN_CANC':'Cancel',
      'BTN_APLI':'Apply',
      'MOD_TITT_INFO':'Survey Information',
      'TXT_NAM_COMPA':'Company name:  ',
      'TXT_NAM_TOKEN':'Survey token:  ',
      'TXT_DAT_LAN':'Launch date:  ',
      'TXT_DAT_CLOS':'Closing date:  ',
      'TXT_SUR_STA':'Survey state:  ',
      'TXT_TIP_SUR':'Product type:  ',
      'TXT_YEA_SUR':'Survey year:  ',
      'ESTATUS':{
        '0':'Inactive',
        '1':'Active',
        '2':'Closed',
      },
      'CAMPOS': {
        'broker': 'Broker',
      },
    }
  }
  };
